<div class="d-flex flex-column w-100">
	<div class="display-14 my-auto">
		<div>Send <i>OrderReady</i> SMS notifications to Online Order, <i>@table</i> and in-store guests on-demand or when orders are bumped.</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div pDroppable="orderReadySmsPlaceholder" (onDrop)="drop($event)" class="h-100">
				<span class="p-float-label mt-4 h-100">
					<textarea
						pInputTextarea
						#orderReadySmsMessageInput
						name="orderReadySmsMessageInput"
						[(ngModel)]="kitchenDevicePreferences.orderReadySmsMessage"
						class="w-100 h-100 mt-1 p-drop-column"
						(change)="changesToSaveChange.emit(true)"
					></textarea>
					<label for="orderReadySmsMessageInput">Order Ready SMS Message</label>
				</span>
			</div>
		</div>
		<div class="p-col-12 p-md-6 d-flex flex-column">
			<div class="mb-2" pDraggable="orderReadySmsPlaceholder" (onDragStart)="dragStart($event, ':checkid')" (onDragEnd)="dragEnd($event)">
				<div class="">
					<div class="ms-4">
						<code>:checkid</code>
						<span class="ms-3 p-text-italic">POS Check Number/ID</span>
					</div>
				</div>
			</div>
			<div class="mb-2" pDraggable="orderReadySmsPlaceholder" (onDragStart)="dragStart($event, ':firstname')" (onDragEnd)="dragEnd($event)">
				<div class="">
					<div class="ms-4">
						<code>:firstname</code>
						<span class="ms-3 p-text-italic">Guest first name from Online Order</span>
					</div>
				</div>
			</div>
			<div class="mb-2" pDraggable="orderReadySmsPlaceholder" (onDragStart)="dragStart($event, ':tableid')" (onDragEnd)="dragEnd($event)">
				<div class="">
					<div class="ms-4">
						<code>:tableid</code>
						<span class="ms-3 p-text-italic">POS Table Name/Number</span>
					</div>
				</div>
			</div>
			<div class="mb-2" pDraggable="orderReadySmsPlaceholder" (onDragStart)="dragStart($event, ':venueaddress')" (onDragEnd)="dragEnd($event)">
				<div class="">
					<div class="ms-4">
						<code>:venueaddress</code>
						<span class="ms-3 p-text-italic">Restaurant's address</span>
					</div>
				</div>
			</div>
			<div class="mb-2" pDraggable="orderReadySmsPlaceholder" (onDragStart)="dragStart($event, ':venuename')" (onDragEnd)="dragEnd($event)">
				<div class="">
					<div class="ms-4">
						<code>:venuename</code>
						<span class="ms-3 p-text-italic">Restaurant's name</span>
					</div>
				</div>
			</div>
			<div class="mb-2" pDraggable="orderReadySmsPlaceholder" (onDragStart)="dragStart($event, ':venueonlineordering')" (onDragEnd)="dragEnd($event)">
				<div class="">
					<div class="ms-4">
						<code>:venueonlineordering</code>
						<span class="ms-3 p-text-italic">Restaurant's FocusOnline Site</span>
					</div>
				</div>
			</div>
			<div class="mb-2" pDraggable="orderReadySmsPlaceholder" (onDragStart)="dragStart($event, ':venuephone')" (onDragEnd)="dragEnd($event)">
				<div class="">
					<div class="ms-4">
						<code>:venuephone</code>
						<span class="ms-3 p-text-italic">Restaurant's phone number</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
